import { render, staticRenderFns } from "./r-checkbox-group.vue?vue&type=template&id=64895c5c&scoped=true&"
import script from "./r-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./r-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./r-checkbox-group.vue?vue&type=style&index=0&id=64895c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64895c5c",
  null
  
)

export default component.exports